module.exports.eventTypes = {
    "incident": 0,
    "legit": 1,
    "unknown": 2,
    "reported_phish" : 3,
    "google_form_password" : 4
};